import { render, staticRenderFns } from "./AIHelper.vue?vue&type=template&id=312abd96&scoped=true"
import script from "./AIHelper.vue?vue&type=script&lang=js"
export * from "./AIHelper.vue?vue&type=script&lang=js"
import style0 from "./AIHelper.vue?vue&type=style&index=0&id=312abd96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312abd96",
  null
  
)

/* custom blocks */
import block0 from "./AIHelper.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports